<template>
  <v-row>
    <v-col cols="12">
      <CommonTable
        list-getter="projectMeteringStore/tariffPeriodStore/getList"
        :headers="headers"
        :slots="slots"
        :actions="actions"
        resource="tariff-period"
        deleteItemDispatch="projectMeteringStore/tariffPeriodStore/delete"
        createItemDispatch="projectMeteringStore/tariffPeriodStore/create"
        updateItemDispatch="projectMeteringStore/tariffPeriodStore/update"
        @updated="updateList"
        :loading.sync="loading"
        :static-dispatch-params="{
          project_id: $route.params.project_id,
          tariff_id: $route.params.id
        }"
        :can-add="!readonly"
        :can-edit="!readonly"
        :can-delete="!readonly"
      ></CommonTable>
      <Paginator
        page-getter="projectMeteringStore/tariffPeriodStore/getPage"
      ></Paginator>
    </v-col>
  </v-row>
</template>

<script>
import Paginator from "../../../common/tables/Paginator";
import CommonTable from "../../../common/tables/CommonTable";
import { rules } from "../../../mixins/rules";
import { projectPermissions } from "../../../mixins/projects/projectPermissions";

export default {
  name: "PricePerUnitTariff",
  components: {
    Paginator,
    CommonTable
  },
  mixins: [rules, projectPermissions],
  data: function() {
    return {
      headers: [
        {
          text: this.$t("tariff-period.valid-from"),
          align: "left",
          value: "valid_from"
        },
        {
          text: this.$t("tariff-period.price"),
          value: "price_per_unit"
        },
        {
          text: this.$t("tariff-period.action"),
          value: "action",
          align: "right",
          sortable: false
        }
      ],
      actions: [],

      loading: false
    };
  },
  computed: {
    slots() {
      let rules = this.rules;
      let project = this.project;
      let tariff = this.tariff;
      return [
        {
          name: "valid_from",
          title: "valid-from",
          type: "date",
          dateFormat: "short",
          form: {
            type: "date",
            rules: [rules.requiredForDate],
            visible: true
          }
        },
        {
          name: "price_per_unit",
          title: "price",
          type: "number",
          decoratorDefault: `${project.currency}/${tariff.unit_symbol}`,
          number_format: "decimal",
          decorator: "currency_per_unit_symbol",
          form: {
            type: "text",
            input_type: "number",
            rules: [rules.required],
            visible: true
          }
        }
      ];
    },
    getParams() {
      return ` ${this.$route.query.page}
                ${this.$route.query.limit_items}
                ${this.$route.query.orders}
                ${this.$route.query.search}
                `;
    },
    tariff: {
      get() {
        return this.$store.getters["projectMeteringStore/tariffStore/getItem"];
      }
    },
    project: function() {
      return this.$store.getters["projectStore/getCurrentItem"];
    },
    readonly: {
      get() {
        return !this.hasCurrentProjectPermissions("tariff.update");
      }
    }
  },

  watch: {
    getParams: function() {
      this.updateList();
    }
  },
  methods: {
    updateList() {
      this.loading = true;
      let params = this.formingParams();
      this.$store.dispatch("projectMeteringStore/tariffPeriodStore/getList", {
        params,
        onSuccess: () => {
          this.loading = false;
        }
      });
    },
    formingParams() {
      return {
        tariff_id: this.$route.params.id,
        project_id: this.$route.params.project_id,
        page: this.$route.query.page,
        limit: this.$route.query.limit_items,
        orders: this.$route.query.orders
      };
    }
  },
  mounted() {
    this.updateList();
  }
};
</script>

<style scoped></style>
